import { useMutation, useQueryClient } from '@tanstack/react-query';
import accesosService from '../services/accesosService';
import { accesosKeys } from '../queryKeys';

// DELETE /accesos/:id (soft-delete). Invalida la lista al revocar. El error
// (p.ej. 404 No encontrado) se propaga para mostrarlo en la pantalla.
const useRevocarAcceso = (headquarter) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id }) => accesosService.revocarAcceso({ headquarter, id }),
    onSuccess: () => qc.invalidateQueries({ queryKey: accesosKeys.lista(headquarter) }),
  });
};

export default useRevocarAcceso;
